import React, { Component } from 'react';
import { Spinner } from 'react-activity';
import Modal from 'react-modal';
import LanguageContext, { LanguageProvider } from '../../../utils/common/LanguageContext';

// Higher-Order Component to inject translation function
const withLanguage = (WrappedComponent) => {
    return class extends Component {
        render() {
            return (
                <LanguageContext.Consumer>
                    {({ t }) => <WrappedComponent {...this.props} t={t} />}
                </LanguageContext.Consumer>
            );
        }
    };
};

class NotesCompleteConfirmation extends Component {
    render() {
        return (
            <Modal
                isOpen={this.props.openModal}
                onRequestClose={this.props.closeModal}
                className={'modal-width'}
                contentLabel="Example"
                overlayClassName={'modal-background z-index-1'}
                ariaHideApp={false}
            >
                <div className="relative w-full max-w-2xl max-h-full">
                    <div className="relative p-6  rounded-lg bg-card">
                        <div className="flex items-start justify-between">
                            <h3 className="mt-0 text-lg font-medium text-white">
                                {this.props.t('clickYesToCompleteSessionNote')}
                            </h3>
                            <button type="button" onClick={() => this.props.closeModal()}>
                                <svg
                                    className="styles_closeIcon__1QwbI"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="28"
                                    height="28"
                                    viewBox="0 0 36 36"
                                >
                                    <path
                                        d="M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z"
                                        fill="white"
                                    ></path>
                                </svg>
                            </button>
                        </div>
                        <div className="flex items-center justify-end pt-6 space-x-2">
                            <button
                                data-modal-hide="defaultModal"
                                className="bg-black rounded-lg font-semibold text-white w-3/12 py-1.5"
                                onClick={() => this.props.closeModal()}
                            >
                                {this.props.t('no')}
                            </button>
                            &nbsp;&nbsp;
                            <button
                                data-modal-hide="defaultModal"
                                className="text-white bg-UIprimary rounded-lg font-semibold text-base w-3/12 py-1.5"
                                onClick={() => this.props.save(1)}
                                disabled={this.props.btnLoading}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    {this.props.btnLoading ? (
                                        <Spinner color="#FFF" />
                                    ) : (
                                        this.props.t('yes')
                                    )}
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

const ConnectedNotesCompleteConfirmation = withLanguage(NotesCompleteConfirmation);

export default (props) => (
    <LanguageProvider>
        <ConnectedNotesCompleteConfirmation {...props} />
    </LanguageProvider>
);
